<template>
    <b-modal id="modal_doc"
                ref="modal_doc"
                size="lg"
                :title="modal_titulo"
                :ok-title="modal_botao"
                close-title="Fechar"
                :ok-disabled=form.errors.any()
                v-model="showModal"
                @ok="handleOk">
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-container fluid class="p-a-0">
                <b-row>
                    <b-col>
                        <label>N° Fiscal</label>
                        <b-form-input type="text"
                                    placeholder="N° Fiscal"
                                    v-model="form.num_fiscal"
                                    name="num_fiscal"
                                    >
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('num_fiscal')" v-if="form.errors.has('num_fiscal')"></b-form-feedback>
                    </b-col>
                    <b-col class="p-l-0">
                        <label>Série</label>
                        <b-form-input type="text"
                                        placeholder="Série"
                                        v-model="form.serie"
                                        name="serie"
                                        >
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('serie')" v-if="form.errors.has('serie')"></b-form-feedback>
                    </b-col>
                    <b-col>
                        <label>Status</label>
                        <multiselect v-model="statusSelected"
                        :options="this.optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        :preselect-first="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('status')" v-if="form.errors.has('status')"></b-form-feedback>
                    </b-col>
                    <b-col>
                      <label>Prefixo Documento</label>
                      <multiselect v-model="tpPrefixoNumControleSelected"
                                   :options="this.optionsLivTpPrefixoNumControle"
                                   track-by="value"
                                   label="label"
                                   :hide-selected="true"
                                   placeholder="Selecione"
                                   tag-placeholder="Selecionar"
                                   select-label="Selecionar"
                                   selected-label="Selecionado"
                                   deselect-label="Remover"
                      ></multiselect>
                      <b-form-feedback class="text-danger" v-text="form.errors.get('tp_prefixo_num_controle')" v-if="form.errors.has('tp_prefixo_num_controle')"></b-form-feedback>
                    </b-col>
                    <b-col class="p-l-0">
                        <label>N° Controle</label>
                        <b-form-input
                            type="text"
                            placeholder="N° Controle"
                            v-model="form.num_controle"
                            name="num_controle">
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('num_controle')" v-if="form.errors.has('num_controle')"></b-form-feedback>
                    </b-col>
                </b-row>
            </b-container>
            <b-container fluid class="p-a-0">
                <b-row>
                    <b-col>
                        <label>Qtde Zeros</label>
                        <b-form-input
                            type="text"
                            placeholder="Qtde Zeros"
                            v-model="form.qtde_zero"
                            name="qtde_zero">
                        </b-form-input>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('qtde_zero')" v-if="form.errors.has('qtde_zero')"></b-form-feedback>
                    </b-col>
                    <b-col class="p-l-0">
                        <label>Tipo Documento</label>
                        <multiselect v-model="tpDocSelected"
                        :options="this.optionsDoc"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('partipdoc_id')" v-if="form.errors.has('partipdoc_id')"></b-form-feedback>
                    </b-col>
                    <b-col>
                        <label></label>
                        <b-form-datepicker
                        placeholder="Data Inicial"
                        reset-button
                        locale="pt-br"
                        v-model="form.dt_inicio"
                        class="form-control"
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                        keyup.enter="doFilter">
                        </b-form-datepicker>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('dt_inicio')" v-if="form.errors.has('dt_inicio')"></b-form-feedback>
                    </b-col>
                    <b-col class="p-l-0">
                        <label></label>
                        <b-form-datepicker
                        placeholder="Data Final"
                        reset-button
                        locale="pt-br"
                        v-model="form.dt_fim"
                        class="form-control"
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }"
                        keyup.enter="doFilter">
                        </b-form-datepicker>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('dt_fim')" v-if="form.errors.has('dt_fim')"></b-form-feedback>

                    </b-col>
                </b-row>
            </b-container>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                <b-btn @click="showModal=false" variant="secondary">
                    Fechar
                </b-btn>
                <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                    Enviar
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'
import moment from 'moment'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalGrupo: false,
        isFullscreen: false,
        statusSelected: [],
        tpDocSelected: [],
        tpPrefixoNumControleSelected: [],
        errors_array: [],
        optionsDoc: [],
        optionsLivStatusDoc: [],
        optionsLivStatus: [],
        optionsLivTpPrefixoNumControle: [],
        helpForm: new Form({
            statusRecord: [],
            params: []
        }),
        form: new Form({
            num_fiscal: '',
            serie: '',
            status: '',
            tp_prefixo_num_controle: '',
            num_controle: '',
            qtde_zero: '',
            unidade_id: '',
            unidoc_id: '',
            partipdoc_id: '',
            dt_inicio: '',
            dt_fim: ''
        }),
        fields: [],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
   }
},
watch: {
    statusSelected(obj){
        this.form.status = obj.value ? obj.value : 1;
    },
    tpDocSelected(obj){
        this.form.partipdoc_id = obj.value;
    },
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if (this._validateForm()) {
            return;    
        }
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.unidoc_id);
        }
    },
    onCreate(data) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Cadastrar conta";
        this.modal_botao = "Cadastrar conta";
        this.modal_acao = "i";
        this.form.reset();
        this.optionsDoc = this.$parent.optionsDoc;
        this.optionsLivStatusDoc = this.$parent.optionsLivStatusDoc;
        this.optionsLivStatus = this.$parent.optionsLivStatus;
        this.optionsLivTpPrefixoNumControle = this.$parent.optionsLivTpPrefixoNumControle;
        this.statusSelected = [];
        this.principalSelected = [];
        this.bancoSelected = [];
        this.form.unidade_id = data.unidade_id;
        this.$refs.modal_doc.show();
    },
    onEdit (data, index) {
        console.log(data);
        console.log(this.$parent.$parent);
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.optionsDoc = this.$parent.$parent.$parent.optionsDoc;
        this.optionsLivStatusDoc = this.$parent.$parent.$parent.optionsLivStatusDoc;
        this.optionsLivStatus = this.$parent.$parent.$parent.optionsLivStatus;
        this.optionsLivTpPrefixoNumControle = this.$parent.$parent.$parent.optionsLivTpPrefixoNumControle;
        this.tpDocSelected = [];
        this.statusSelected = [];
        this.form.unidade_id = data.unidade_id;
        this.form.num_fiscal = data.num_fiscal;
        this.form.serie = data.serie;
        this.form.num_controle = data.num_controle;
        this.form.qtde_zero = data.qtde_zero;
        this.form.dt_inicio = new Date(data.dt_inicio);
        if(data.dt_fim!=null)
        {
            this.form.dt_fim = new Date(data.dt_fim);
        }
        this.form.unidoc_id = data.unidoc_id;
        this.tpDocSelected = { label: data.param_tipo_doc.descr, value: data.param_tipo_doc.partipdoc_id };
        this.statusSelected    = { label: data.status.descr, value: data.status.valor };
        this.tpPrefixoNumControleSelected = this.optionsLivTpPrefixoNumControle.find(item => item.value == data.tp_prefixo_num_controle);
        this.$refs.modal_doc.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.partipdoc_id = this.tpDocSelected.value;
        this.form.tp_prefixo_num_controle = this.tpPrefixoNumControleSelected.value;
        this.form.dt_inicio = this.formatDateSubmit(this.form.dt_inicio);
        this.form.dt_fim = this.formatDateSubmit(this.form.dt_fim);
        this.form.post('/api/unidade/documento/store').then(response =>
        {
            new ReturnApi(response, this)
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.partipdoc_id = this.tpDocSelected.value;
        this.form.tp_prefixo_num_controle = this.tpPrefixoNumControleSelected.value;
        this.form.dt_inicio = this.formatDateSubmit(this.form.dt_inicio);
        this.form.dt_fim = this.formatDateSubmit(this.form.dt_fim);
        this.form.patch('/api/unidade/documento/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
      return (value == null || value == "")
      ? ''
      : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/unidade/documento/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    _validateForm() {
        let errors = {};
        if (!this.form.num_fiscal) {
            errors = {
                ...errors,
                num_fiscal: ['Número fiscal é obrigatório']
            };
        }
        if (!this.form.serie) {
            errors = {
                ...errors,
                serie: ['Série é obrigatório']
            };
        }
        if (
            !this.statusSelected ||
            !Object.keys(this.statusSelected).length > 0
        ) {
            errors = {
                ...errors,
                status: ['Status é obrigatório']
            };
        }
        if (
            !this.tpPrefixoNumControleSelected ||
            !Object.keys(this.tpPrefixoNumControleSelected).length > 0
        ) {
            errors = {
                ...errors,
                tp_prefixo_num_controle: ['Prefixo do número de controle é obrigatório']
            };
        }
        if (!this.form.num_controle) {
            errors = {
                ...errors,
                num_controle: ['Número de controle é obrigatório']
            };
        }
        if (!this.form.qtde_zero) {
            errors = {
                ...errors,
                qtde_zero: ['Quantidade de zeros é obrigatório']
            };
        }
        if (
            !this.tpDocSelected ||
            !Object.keys(this.tpDocSelected).length > 0
        ) {
            errors = {
                ...errors,
                partipdoc_id: ['Tipo de documento é obrigatório']
            };
        }
        if (!this.form.dt_inicio) {
            errors = {
                ...errors,
                dt_inicio: ['Data inicial é obrigatória']
            };
        }
        this.form.errors.record(errors);
        return this.form.errors.any();
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
<style>
#modal_doc .modal-lg{
    max-width: 60% !important;
}
</style>
